module.exports = __webpack_public_path__ + "assets/b89f68061fb7b2829b7f168d976ee070.png";